import { render } from "./ManageResponses.vue?vue&type=template&id=205b1752"
import script from "./ManageResponses.vue?vue&type=script&lang=js"
export * from "./ManageResponses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__